/* global SideDrawer, Swiper */

if (!customElements.get('quick-add-drawer')) {
  class QuickAddDrawer extends SideDrawer {
    constructor() {
      super();

      this.content = this.querySelector('.js-product-details');

      document.addEventListener('click', this.handleDocumentClick.bind(this));
      this.addEventListener('on:variant:change', this.handleDrawerVariantChange.bind(this));
    }

    // Keep the drawer's single-price display in sync if the buyer switches
    // Unit / Box via the variant picker inside the drawer.
    handleDrawerVariantChange(evt) {
      const variant = evt.detail && evt.detail.variant;
      if (!variant) return;

      const isBox = /box of|carton/i.test(variant.title || '');
      const type = isBox ? 'box' : 'unit';

      this.querySelectorAll('.quick-popup-price-item[data-price-type]').forEach((el) => {
        el.hidden = el.dataset.priceType !== type;
      });
    }

    handleDocumentClick(evt) {
      const optionBtn = evt.target.closest('.js-wholesale-card-option');
      if (optionBtn) {
        this.updateWholesaleCardOption(optionBtn);
        return;
      }

      const btn = evt.target.closest('.js-quick-add');
      if (!btn) return;

      evt.preventDefault();
      this.open(btn);
    }

    updateWholesaleCardOption(optionBtn) {
      const card = optionBtn.closest('[data-wholesale-product-card]');
      if (!card) return;

      card.querySelectorAll('.js-wholesale-card-option').forEach((btn) => {
        const active = btn === optionBtn;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      // Show only the price matching the selected purchase type (unit / box).
      const selectedType = optionBtn.dataset.purchaseType;
      if (selectedType) {
        card.querySelectorAll('[data-price-type]').forEach((priceEl) => {
          priceEl.hidden = priceEl.dataset.priceType !== selectedType;
        });
      }

      const quickAddBtn = card.querySelector('.js-quick-add');
      if (!quickAddBtn) return;

      quickAddBtn.dataset.productUrl = optionBtn.dataset.productUrl;
      quickAddBtn.dataset.selectedVariantId = optionBtn.dataset.variantId;
      if (selectedType) quickAddBtn.dataset.selectedType = selectedType;
    }

    async open(opener) {
      opener.setAttribute('aria-disabled', 'true');

      this.opener = opener;
      this.productUrl = opener.dataset.productUrl;
      const wholesaleContext = Boolean(opener.closest('#wholesale-product-section'));
      this.dataset.wholesaleContext = wholesaleContext ? 'true' : 'false';

      this.content.innerHTML = `
        <div class="quick-add-loading">
          <span class="quick-add-loader"></span>
          <p>Loading product...</p>
        </div>
      `;

      super.open(opener);

      try {
        const response = await fetch(this.productUrl);

        if (response.ok) {
          const tmpl = document.createElement('template');
          tmpl.innerHTML = await response.text();

          this.productEl = tmpl.content.querySelector('.cc-main-product .js-product');

          if (this.productEl) {
            this.renderProduct(opener);
          }
        }
      } catch (error) {
        console.error('Quick add error:', error);
      }

      opener.removeAttribute('aria-disabled');
    }

    renderProduct(opener) {
      const sectionId = this.productEl.dataset.section;

      if (sectionId) {
        this.productEl.innerHTML = this.productEl.innerHTML.replaceAll(sectionId, 'quickadd');
      }

      this.updateContent(opener);
      this.updateForm(opener);
    }

    updateContent(opener) {
      let slidesHTML = '';

      const mediaItems = this.productEl.querySelectorAll('[data-media-id]');

      mediaItems.forEach((item) => {
        const img = item.querySelector('img');
        if (!img) return;

        const imgSrc = img.src || img.dataset.src || '';
        const src = imgSrc.split('&width=')[0];

        slidesHTML += `
          <div class="swiper-slide">
            <img src="${src}&width=450" alt="${img.alt || ''}">
          </div>
        `;
      });

      const unitPrice = opener.dataset.unitPrice || '';
      const boxPrice = opener.dataset.boxPrice || '';
      const boxQuantity = opener.dataset.boxQuantity || '';
      const selectedType = opener.dataset.selectedType || 'unit';

      this.content.innerHTML = `
        <div class="quick-add-info">

          <div class="quick-add-info__media">
            <div class="swiper quick-add-slider">
              <div class="swiper-wrapper">
                ${slidesHTML}
              </div>
              <div class="swiper-button-next thumb-arrow-next-slide"></div>
              <div class="swiper-button-prev thumb-arrow-prev-slide"></div>
            </div>

            <div class="swiper quick-thumb-slider">
              <div class="swiper-wrapper">
                ${slidesHTML}
              </div>
            </div>
          </div>

          <div class="quick-add-info__details">

            <div class="product-title">
              ${this.getHTML('.product-title')}
            </div>

            <div class="product-options">
              ${this.getHTML('.product-options')}
            </div>

           
            <div class="quick-add-cart"></div>

            <div class="quick-popup-price-list">
              ${unitPrice ? `
                <p class="quick-popup-price-item" data-price-type="unit" ${selectedType === 'box' ? 'hidden' : ''}>
                  <strong>Unit Price:</strong>
                  <span>${unitPrice}</span>
                </p>
              ` : ''}

              ${boxPrice && boxQuantity ? `
                <p class="quick-popup-price-item" data-price-type="box" ${selectedType === 'unit' ? 'hidden' : ''}>
                  <strong>Box Price (${boxQuantity}):</strong>
                  <span>${boxPrice}</span>
                </p>
              ` : ''}
            </div>


          </div>
        </div>
      `;

      setTimeout(() => {
        const galleryThumbs = new Swiper('.quick-thumb-slider', {
          spaceBetween: 5,
          slidesPerView: 'auto',
          slideToClickedSlide: true
        });

        new Swiper('.quick-add-slider', {
          slidesPerView: 1,
          spaceBetween: 12,
          grabCursor: true,
          navigation: {
            nextEl: '.thumb-arrow-next-slide',
            prevEl: '.thumb-arrow-prev-slide'
          },
          thumbs: {
            swiper: galleryThumbs
          },
          a11y: false
        });
      }, 100);
    }

    updateForm(opener) {
      const productForm = this.productEl.querySelector('product-form');
      const newForm = this.querySelector('.quick-add-cart');

      if (!productForm || !newForm) return;

      newForm.innerHTML = productForm.outerHTML;

      const selectedVariantId = opener.dataset.selectedVariantId;
      const variantInput = newForm.querySelector('input[name="id"]');
      if (selectedVariantId && variantInput) {
        variantInput.value = selectedVariantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const formElement = newForm.querySelector('product-form');

      if (formElement && typeof formElement.init === 'function') {
        formElement.init();
      }
    }

    getHTML(selector) {
      const el = this.productEl.querySelector(selector);
      return el ? el.innerHTML : '';
    }
  }

  customElements.define('quick-add-drawer', QuickAddDrawer);
}
